(function () {
  if (customElements.get('division-slider')) return;

  /**
   * Übergangs-Effekte liegen in einer eigenen Registry, damit später weitere
   * (z. B. "fade") ergänzt werden können, ohne die Slider-Logik anzufassen.
   * Jede Funktion bekommt die Slider-Instanz und ob animiert werden soll.
   */
  const transitions = {
    slide(instance, animate) {
      const offset = instance.slideStep() * instance.index;
      instance.track.style.transition = animate
        ? `transform ${instance.speed}ms cubic-bezier(.4,0,.2,1)`
        : 'none';
      instance.track.style.transform = `translateX(-${offset}px)`;
    }
  };

  function cloneSlide(el) {
    const clone = el.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.setAttribute('tabindex', '-1');
    return clone;
  }

  class DivisionSlider extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.division-generic-slider-viewport');
      this.track = this.querySelector('.division-generic-slider-track');
      if (!this.track) return;

      const originals = Array.from(this.track.children);
      this.count = originals.length;

      this.visible = Math.max(1, parseInt(this.dataset.visible, 10) || 1);
      this.step = Math.max(1, parseInt(this.dataset.step, 10) || 1);
      this.transitionName = this.dataset.transition || 'slide';
      this.speed = Math.max(0, parseInt(this.dataset.speed, 10) || 500);
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.autoplayDelay = Math.max(500, parseInt(this.dataset.autoplayDelay, 10) || 3500);
      this.pauseOnHover = this.dataset.pauseHover === 'true';

      this.loop = this.count > this.visible;

      if (this.loop) {
        const before = originals.map(cloneSlide);
        const after = originals.map(cloneSlide);
        this.track.innerHTML = '';
        [...before, ...originals, ...after].forEach((el) => this.track.appendChild(el));
        this.index = this.count;
      } else {
        this.index = 0;
      }

      this.prevBtn = this.querySelector('.division-generic-slider-prev');
      this.nextBtn = this.querySelector('.division-generic-slider-next');

      if (!this.loop) {
        if (this.prevBtn) this.prevBtn.hidden = true;
        if (this.nextBtn) this.nextBtn.hidden = true;
      } else {
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.handleNav(this.step));
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.handleNav(-this.step));
      }

      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
      }

      this._onResize = () => this.render(false);
      window.addEventListener('resize', this._onResize);

      this.render(false);
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      window.removeEventListener('resize', this._onResize);
    }

    handleNav(delta) {
      this.stopAutoplay();
      this.go(delta);
      this.startAutoplay();
    }

    slideStep() {
      const slide = this.track.children[0];
      if (!slide) return 0;
      const rect = slide.getBoundingClientRect();
      const styles = window.getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return rect.width + gap;
    }

    render(animate) {
      const fn = transitions[this.transitionName] || transitions.slide;
      fn(this, animate);
    }

    go(delta) {
      this.index += delta;
      this.render(true);
      if (!this.loop) return;

      window.setTimeout(() => {
        if (this.index >= this.count * 2) {
          this.index -= this.count;
          this.render(false);
        } else if (this.index < this.count) {
          this.index += this.count;
          this.render(false);
        }
      }, this.speed);
    }

    startAutoplay() {
      if (!this.autoplayEnabled || !this.loop) return;
      this.stopAutoplay();
      this.timer = window.setInterval(() => this.go(this.step), this.autoplayDelay);
    }

    stopAutoplay() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  customElements.define('division-slider', DivisionSlider);
})();
